import React, { useMemo } from 'react';
import { Typography } from '@mui/material';

import Table from '../../../../components/tables/Table';

const COLUMNS = [
  {
    label: 'Request Type',
    field: 'reqtype',
    type: 'string',
    sortable: true,
    render: (_row, v) => <Typography variant="body2">{v ?? '—'}</Typography>,
  },
  {
    label: 'Filename',
    field: 'fileName',
    type: 'string',
    sortable: true,
    render: (_row, v) => <Typography variant="body2">{v ?? '—'}</Typography>,
  },
  {
    label: 'Status',
    field: 'status',
    type: 'string',
    sortable: true,
    render: (_row, v) => <Typography variant="body2">{v ?? '—'}</Typography>,
  },
  {
    label: 'Message',
    field: 'message',
    type: 'string',
    sortable: true,
    cellSx: {
      maxWidth: 600,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    render: (_row, v) => (
      <Typography variant="body2" noWrap title={v || ''}>
        {v ?? '—'}
      </Typography>
    ),
  },
  {
    label: 'Log Date',
    field: 'logDate',
    type: 'date',
    sortable: true,
    accessor: (row) => {
      const d = row?.logDate ?? row?.LogDate;
      const t = Date.parse(d);
      return Number.isFinite(t) ? t : 0;
    },
    render: (row) => {
      const d = row?.logDate ?? row?.LogDate;
      const t = Date.parse(d);
      return (
        <Typography variant="body2">
          {Number.isFinite(t) ? new Date(t).toLocaleDateString('en-GB') : '—'}
        </Typography>
      );
    },
  },
];

export default function StructureLogTable({ rows = [], refreshing = false }) {
  console.log(
    '[StructureLogTable] rows:',
    Array.isArray(rows) ? rows.length : 0,
    rows?.[0]
  );

  const columns = useMemo(() => COLUMNS, []);

  return (
    <Table
      rows={Array.isArray(rows) ? rows : []}
      columns={columns}
      stickyHeader
      zebra
      hover
      bordered

      defaultSort={{ field: 'logDate', direction: 'desc' }}
    />
  );
}
